import Vue, { VNode } from 'vue'

import App from './app.vue'
import router from './router'
import store from './store'

// 引入神策
import { hawkeyeInit } from './sensor'
import './api'
import './utils/mobile-extend'

import 'normalize.css'
import '@/styles/common.less'

// 初始化数据收集
hawkeyeInit()

new Vue({
  el: '#app',
  router,
  store,
  render: (createElement): VNode => createElement(App)
})
